import AuraSuite from "src/images/aura_suite.svg";
import FlushAccordian from "src/SharedComponents/FlushAccordian/FlushAccordian";
import { IAuraSoftwareSuiteLicensesInfo, IClinic } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import { useCallback, useEffect, useState } from "react";
import AuraSoftwareSuitesAssigned from "./AuraSoftwareSuitesAssigned/AuraSoftwareSuitesAssigned";
import AuraSoftwareSuitesUnassigned from "./AuraSoftwareSuitesUnassigned/AuraSoftwareSuitesUnassigned";
import { useTranslation } from "react-i18next";

export interface IAuraSoftwareSuiteLicenses{
    auraSoftwareSuiteLicenses: IAuraSoftwareSuiteLicensesInfo[];
    clinics: IClinic[] | undefined;
    distributorId: string;
}

const AuraSoftwareSuiteLicenses: React.FC<IAuraSoftwareSuiteLicenses> = ({auraSoftwareSuiteLicenses, clinics, distributorId}) => {
    const {t} = useTranslation();
    const [assignedLicenses, setAssignedLicenses] = useState<IAuraSoftwareSuiteLicensesInfo[]>([]);
    const [unassignedLicenses, setUnassignedLicenses] = useState<IAuraSoftwareSuiteLicensesInfo[]>([]);

    const getLicensesByClinic = useCallback((assignedToClinic: boolean) => {
        return auraSoftwareSuiteLicenses && auraSoftwareSuiteLicenses?.filter((license: IAuraSoftwareSuiteLicensesInfo) => license?.isAssignedToClinic === assignedToClinic);
    }, [auraSoftwareSuiteLicenses]);

    useEffect(() => {
        var assignedlicenses = getLicensesByClinic(true);
        var unassignedlicenses = getLicensesByClinic(false);
        setAssignedLicenses(assignedlicenses);
        setUnassignedLicenses(unassignedlicenses);
    }, [getLicensesByClinic])

    return(
        <>
            <FlushAccordian title={t('AuraSoftwareSuites')} id="AuraSoftwareSuitesLicenses" titleImage={AuraSuite} titleImageWidth="42px" marginLeftImage="15px" marginRightImage="20px">
                <div className="pt-4">
                    {
                        assignedLicenses.length > 0 ? <AuraSoftwareSuitesAssigned auraSoftwareSuitesLicensesAssigned={getLicensesByClinic(true)} distributorId={distributorId}/> : <></>
                    }
                    {
                        unassignedLicenses.length > 0 ? <AuraSoftwareSuitesUnassigned auraSoftwareSuitesLicensesUnassigned={getLicensesByClinic(false)} clinics={clinics} distributorId={distributorId}/> : <></>
                    }
                </div>
            </FlushAccordian>
        </>
    );
}

export default AuraSoftwareSuiteLicenses;